<template>
  <div>
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      @close="closeToast"
    />
    <div>
      <LoaderTuin :is-loading="loader" />
    </div>
    <div class="px-0 sm:w-[760px] sm:mb-0 mb-16" v-if="!loader">
      <p class="text-lg font-medium text-black mb-4">Ubicación</p>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Código Postal -->
        <div>
          <label for="zipcode" class="block mb-2 text-sm font-medium text-custom_gray">Código Postal*</label>
          <input
            id="zipcode"
            v-model="zipcode"
            type="text"
            inputmode="numeric"
            maxlength="5"
            autocomplete="postal-code"
            placeholder="Ingresa el código postal"
            @input="onZipInput"
            @blur="onZipBlur"
            class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full px-3"
          />
        </div>
        <!-- Estado -->
        <div>
          <label for="state" class="block mb-2 text-sm font-medium text-custom_gray">Estado*</label>
          <SelectComponent
            id="state"
            ref="stateRef"
            v-model="state"
            :options="states"
            :placeholder="'Selecciona el estado'"
            :multiple="false"
            :show-all="false"
            :width-class="'w-full'"
            :font-size="'text-base'"
            @open="closeOthers('state')"
            @change="handleActiveMap"
          />
        </div>
        <!-- Alcaldía / Municipio -->
        <div>
          <label for="municipality" class="block mb-2 text-sm font-medium text-custom_gray">Alcaldía / Municipio*</label>
          <input
            id="municipality"
            v-model="municipality"
            type="text"
            placeholder="Ingresa la alcaldía / municipio"
            @input="handleActiveMap"
            :readonly="municipality !== ''"
            class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full px-3"
          />
        </div>
        <!-- Ciudad -->
        <div>
          <label for="city" class="block mb-2 text-sm font-medium text-custom_gray">Ciudad*</label>
          <input
            id="city"
            v-model="city"
            type="text"
            placeholder="Ingresa la ciudad"
            @input="handleActiveMap"
            :readonly="city !== ''"
            class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full px-3"
          />
        </div>
        <!-- Colonia -->
        <div>
          <label for="colony" class="block mb-2 text-sm font-medium text-custom_gray">Colonia*</label>
          <SelectComponent
            id="colony"
            ref="colonyRef"
            v-model="colony"
            :options="colonies"
            :placeholder="'Selecciona la colonia'"
            :multiple="false"
            :show-all="false"
            :width-class="'w-full'"
            :font-size="'text-base'"
            @open="closeOthers('colony')"
            @change="handleActiveMap"
          />
        </div>
        <!-- Calle -->
        <div>
          <label for="street" class="block mb-2 text-sm font-medium text-custom_gray">
            {{ [1,2,3,5,7,8].includes(type_property_id) ? 'Calle*' : 'Calle' }}
          </label>
          <input
            id="street"
            v-model="street"
            type="text"
            placeholder="Ingresa la calle"
            @input="handleActiveMap"
            class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full px-3"
          />
        </div>
        <!-- Número exterior -->
        <div>
          <label for="no_ext" class="block mb-2 text-sm font-medium text-custom_gray">
            {{ [1,2,3,5,7,8].includes(type_property_id) ? 'Número exterior*' : 'Número exterior' }}
          </label>
          <input
            id="no_ext"
            v-model="no_ext"
            type="text"
            maxlength="10"
            placeholder="Ingresa el número exterior"
            @input="handleActiveMap"
            class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full px-3"
          />
        </div>
        <!-- Número interior -->
        <div>
          <label for="no_int" class="block mb-2 text-sm font-medium text-custom_gray">Número interior</label>
          <input
            id="no_int"
            v-model="no_int"
            type="text"
            maxlength="10"
            placeholder="Ingresa el número interior"
            class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0  block w-full px-3"
          />
        </div>
      </div>
      <!-- Botón de ubicación -->
      <div class="mt-6">
        <button
          type="button"
          :disabled="!isActiveLocation"
          @click="openModalMaps"
          class="hidden px-5 py-2.5 rounded-lg text-sm font-medium bg-tuin-100 text-white disabled:opacity-40 disabled:cursor-not-allowed hover:bg-tuin_hover"
        >
          Ver mapa
        </button>
      </div>
      <!-- Mapa debajo del formulario -->
      <div v-if="showModal" id="map-section" class="fade-in mt-6 mx-2">
        <ModalMapsComponent
          :address="address"
          :export_lat="property_lt"
          :export_ln="property_ln"
          @update-location="handleLocationUpdate"
        />
      </div>

      <div class="mt-6 hidden flex-col-1 justify-end items-end">
        <button type="button" @click="save()" class="w-full sm:w-auto px-5 py-2.5 rounded-lg text-sm font-medium text-white bg-tuin-100 hover:bg-tuin_hover transition-colors">Siguiente</button>
      </div>
    </div> 
  </div>
</template>

<script setup>
import ToastAlert from "@/commond/ToastAlert.vue";
import SelectComponent from '@/components/common/SelectComponent.vue';

import {
  ref,
  onBeforeMount,
  computed,
  defineProps,
  watch,
  defineEmits,
  nextTick,
} from "vue";

import ModalMapsComponent from "@/components/properties/ModalMapsComponent.vue";
import axios from "axios";
import { useStore } from "vuex";
import { usePropertySync } from "@/composables/usePropertySync";
const store = useStore();
let session = computed(() => store.getters.getUserSession);
const {
  syncWithPropiedades: syncWithPropiedadesShared,
  syncWithEasyBroker: syncWithEasyBrokerShared,
} = usePropertySync();
import LoaderTuin from "@/commond/LoaderTuin.vue";

const props = defineProps({
  resp: {
    type: Object,
    required: true,
    default: () => ({ property_name: "" }),
  },
  propertyId: {
    type: Number,
    required: true,
    default: 0,
  },
   isAvailable: {
    type: Boolean,
    default: false
  }
});

// Definimos la variable reactiva que controla la visibilidad de la modal.
let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");

let showModal = ref(false);
let isActiveLocation = ref(false);
let zipcode = ref("");

let state = ref("");
let municipality = ref("");
let city = ref("");
let colony = ref("");
let street = ref("");
let no_int = ref("");
let no_ext = ref("");
let property_lt = ref("");
let property_ln = ref("");

let municipalities = ref([]);
let states = ref([]);
let colonies = ref([]);
let address = ref("");

let loader = ref(false);

const emit = defineEmits(["triggerUpdate", "reset-map"]);
const stateRef  = ref(null);
const colonyRef = ref(null);

function closeOthers(except) {
  if (except !== 'state') stateRef.value?.close();
  if (except !== 'colony') colonyRef.value?.close();
}

async function handleActiveMap() {
  if (
    zipcode.value != "" &&
    municipality.value != "" &&
    city.value != "" &&
    colony.value != "" &&
    street.value != "" &&
    no_ext.value != ""
  ) {
    isActiveLocation.value = true;
  }
}

// Configurar CKEditor
function openModalMaps() {
  // Filtrar el objeto con id 9 y obtener el estado
  const estadoFiltrado = states.value.find(
    (estado) => estado.value === state.value
  );

  const index = colonies.value.findIndex(
    (item) => item.value === parseInt(colony.value)
  );
  const coloniesFiltrado = colonies.value[index].name;
  //let selected = colony.value.toString();
  // Obtener el texto de la opción seleccionada
  address.value = `${street.value} ${no_ext.value}, ${coloniesFiltrado},  ${municipality.value}, ${city.value}, ${estadoFiltrado.name}`;

  showModal.value = true; // mostrar mapa debajo
  // Scroll suave hacia el mapa
  nextTick(()=>{
    const el = document.getElementById('map-section');
    if(el){
      el.scrollIntoView({ behavior:'smooth', block:'start'});
    }
  });
}

async function GetState() {
  loader.value = true;
  let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/catalogue/states`;

  var options = {
    headers: {
      "Content-Type": "application/json", // Es importante establecer el tipo de contenido para el envío de archivos
    },
  };

  axios
    .get(url_cnn, options)
    .then((response) => {
      var resp = response.data.resp;
      states.value = resp.map((estado) => {
        return {
          value: estado.id, // Usando el id como value
          name: estado.estado, // Usando el nombre del estado como name
        };
      });
    })
    .catch((error) => {
      console.log("+++", error.response);
      // if(error.response.status == 401){
      //     console.log('Debe cerrar la sesión')
      // }
    })
    .finally(() => {
      loader.value = false;
    });
}

async function ConsultZip(zipCode) {
  loader.value = true;
  let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/catalogue/cp/${zipCode}`;

  var options = {
    headers: {
      "Content-Type": "application/json", // Es importante establecer el tipo de contenido para el envío de archivos
      //'Authorization': `Bearer ${session.value.token_api}` // Reemplaza tuTokenBearer con tu token real
    },
  };

  axios
    .get(url_cnn, options)
    .then((response) => {
      var resp = response.data.data;
      // verifica que el CP retorne datos
      if (resp.length > 0) {
        // Sacar el estado
        state.value = resp[0]["estado_id"];

        //asignar municipio
        municipalities.value = [
          {
            value: resp[0]["municipio_id"],
            name: resp[0]["municipio"],
          },
        ];

        //municipality.value = resp[0]["municipio_id"];
        municipality.value = resp[0]["municipio"];
        city.value = resp[0]["ciudad"];
        

        //asignar colonia
        if (resp.length == 1) {
          // Solo aplica si nada mas me retorna un resultado
          if (colony.value == "") {
            colony.value = resp[0]["id"];
          }
        }

        colonies.value = resp.map((colony) => {
          return {
            value: colony.id, // Usando el id como value
            name: colony.colonia, // Usando el nombre del estado como name
          };
        });
      } else {
        toastAlert.value = true;
        typeMsg.value = "danger";
        msg.value = "Verifica tu código postal";
        setTimeout(() => {
          closeToast();
        }, 3000);
      }
    })
    .catch((error) => {
      if (error.response.status == 401) {
        console.log("Debe cerrar la sesión");
      }
    })
    .finally(() => {
      loader.value = false;
    });
}

// Modifica las funciones existentes y agrega las nuevas
// --- ZIPCODE helpers con input nativo ---
function sanitizeZip(val){
  if(val == null) return '';
  return String(val).replace(/[^0-9]/g,'').slice(0,5);
}

function clearLocationFields(){
  // Limpiar campos de ubicación que se rellenan al cambiar CP
  municipality.value = "";
  city.value = "";
  colony.value = "";
  colonies.value = [];
  street.value = "";
  no_ext.value = "";
  no_int.value = "";

  // Limpiar mapa y mostrar botón nuevamente
  showModal.value = false;
  property_lt.value = "";
  property_ln.value = "";
  
  // Resetear estado de activación
  isActiveLocation.value = false;
  
  // Emitir evento para resetear mapOpened en el padre
  emit("reset-map");
}

async function onZipInput(e){
  const prev = zipcode.value ?? '';
  const incoming = e?.target?.value ?? '';
  zipcode.value = sanitizeZip(incoming);
  if(zipcode.value.length === 5 && prev !== zipcode.value){
    clearLocationFields();
    await ConsultZip(zipcode.value);
    handleActiveMap();
  } else if(zipcode.value.length < 5){
    isActiveLocation.value = false; // fuerza revalidación hasta completar
  }
}
async function onZipBlur(){
  const current = (zipcode.value ?? '').toString();
  if(current.length === 5){
    clearLocationFields();
    await ConsultZip(current);
    handleActiveMap();
  } else if(current.length > 0){
    showToast('danger','El código postal debe tener 5 dígitos');
  }
}


async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

// Función para manejar la actualización de la ubicación
function handleLocationUpdate(location) {
  property_lt.value = location.lat_export;
  property_ln.value = location.lng_export;
}

async function save() {
  const hasTwoWords = street.value.trim().split(/\s+/).length >= 2;

  if (!hasTwoWords) {
    showToast("danger", "El campo calle es obligatorio (mínimo 2 palabras).");
    return;
  }

  let post_params = {
    property_lt: property_lt.value,
    property_ln: property_ln.value,
    zipcode: zipcode.value,
    state: state.value,
    municipality: municipality.value,
    city: city.value,
    colony: colony.value,
    street: street.value,
    no_int: no_int.value,
    no_ext: no_ext.value,
  };

  let isUpdating = false;

  if (props.propertyId != 0) {
    post_params["property_id"] = props.propertyId;
    isUpdating = true;
  }

  let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/save_location`;
  let options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url, post_params, options);

    if (response.status == 401) {
      console.log("Hay que sacarlo de la sesión");
    }

    if (response.status == 200) {

      showToast("success", response.data.message);
      emit("triggerUpdate", response.data.resp.id);

      // 🔹 Sincronización con propiedades.com si es actualización
      if (isUpdating && props.isAvailable) {
        await syncWithPropiedades(props.propertyId);
        await syncWithEasyBroker(props.propertyId);
      }
      return true;
    }
  } catch (error) {
    console.error("Error fetching data:", error);

    const resp = error.response?.data;

    if (error.response && error.response.status == 422) {
      for (const field in resp.errors) {
        resp.errors[field].forEach((message) => {
          toastAlert.value = true;
          typeMsg.value = "danger";
          msg.value = message;
        });
      }

      setTimeout(() => {
        closeToast();
      }, 3000);
    }
    return false;
  }
}

async function syncWithPropiedades(propertyId) {
  return syncWithPropiedadesShared(propertyId);
}
async function syncWithEasyBroker(propertyId) {
  return syncWithEasyBrokerShared(propertyId, {
    endpoint: "editar",
    onSuccess: () => {
      showToast("success", "Propiedad sincronizada con EasyBroker");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    },
    onError: () => {
      showToast("error", "Error al sincronizar con EasyBroker");
    },
  });
}
async function showToast(type, message) {
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast();
  }, 3000);
}

onBeforeMount(async () => {
  await GetState();
});


let type_property_id = ref(null);
watch(
  () => [props.resp.location, props.resp],
  async ([newVal, obj_resp]) => {
    // Declaramos el callback como async
    
    type_property_id.value = obj_resp ? obj_resp.type_property_id:0;

  zipcode.value = newVal && newVal.zipcode ? sanitizeZip(newVal.zipcode) : "";
    colony.value = newVal ? Number(newVal.neighborhood) : "";
    state.value = newVal ? newVal.state : "";
    municipality.value = newVal ? newVal.municipality : "";
    city.value = newVal ? newVal.city : "";
    street.value = newVal ? newVal.street : "";
    no_int.value = newVal ? newVal.int_number : "";
    no_ext.value = newVal ? newVal.ext_number : "";
    property_lt.value = newVal ? newVal.property_lt : "";
    property_ln.value = newVal ? newVal.property_ln : "";

    if (newVal && newVal.zipcode) {
      await ConsultZip(newVal.zipcode);
      handleActiveMap();
    }
  },
  { immediate: true }
);

// Exponer el método save, openModalMaps y las coordenadas para que puedan ser accedidos desde el componente padre
defineExpose({
  save,
  openModalMaps,
  property_lt,
  property_ln,
  isActiveLocation
});
</script>
  
  
  <style scoped>
/* Animación personalizada */
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-fade-in {
  animation: fade-in 0.5s ease-in-out;
}
</style>